import { createAsyncThunk } from '@reduxjs/toolkit'
import { instance } from '../api/api'
import { ClientsType } from './types'

export const getClients = createAsyncThunk(
  'clients/getClients',
  async ({ token }: { token: string }, thunkAPI) => {
    try {
      const response = await instance.get<ClientsType[]>('clients', {
        headers: { authorization: `Bearer ${token}` },
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Ошибка при получении клиентов')
    }
  },
)

export const getCurrentClient = createAsyncThunk(
  'clients/getCurrentClient',
  async ({ id, token }: { id: number; token: string }, thunkAPI) => {
    try {
      const response = await instance.get<ClientsType>(`clients/${id}`, {
        headers: { authorization: `Bearer ${token}` },
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Ошибка при получении клиента')
    }
  },
)

export const createClient = createAsyncThunk(
  'clients/createClient',
  async ({ data, token }: { data: any; token: string }, thunkAPI) => {
    try {
      const response = await instance.post('clients', data, {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || 'Ошибка при создании клиента',
      )
    }
  },
)

export const deleteClient = createAsyncThunk(
  'clients/deleteClient',
  async ({ id, token }: { id: number; token: string }, thunkAPI) => {
    try {
      const response = await instance.delete(`clients/${id}`, {
        headers: { authorization: `Bearer ${token}` },
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Ошибка при удалении клиента')
    }
  },
)

export const updateClient = createAsyncThunk(
  'clients/updateClient',
  async (
    {
      clientId,
      data,
      token,
    }: { clientId: number | string; data: Partial<ClientsType>; token: string },
    thunkAPI,
  ) => {
    try {
      const response = await instance.patch<ClientsType>(`clients/${clientId}`, data, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data || 'Ошибка при обновлении клиента')
    }
  },
)
